var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9101 11.62C20.9101 16.51 17.3601 21.09 12.5101 22.43C12.1801 22.52 11.8201 22.52 11.4901 22.43C6.64008 21.09 3.09009 16.51 3.09009 11.62V7.23003C3.09009 6.41003 3.7101 5.48004 4.4801 5.17004L10.0501 2.89007C11.3001 2.38007 12.7101 2.38007 13.9601 2.89007L19.5301 5.17004C20.2901 5.48004 20.9201 6.41003 20.9201 7.23003L20.9101 11.62Z",
    stroke: "#CACACA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05005 13.04L10.66 14.65L14.96 10.35",
    stroke: "#CACACA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.deb8e4e37f09cb71cf935646e9534df6.svg";
export { ForwardRef as ReactComponent };